(function () {
  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bb-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.06,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  // First section is handled by the page entrance animation (bb-page-entering)
  // All subsequent sections get scroll-triggered reveal; footer sections are excluded
  var sections = document.querySelectorAll('.shopify-section');
  sections.forEach(function (section, index) {
    if (index === 0) return;
    if (section.closest('footer')) return;
    section.classList.add('bb-section-reveal');
    observer.observe(section);
  });
})();
